import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
const messages = {
	'en': {
		'back': 'Back',

		'dyk-black.en.png': 'dyk-black.en.png',
		'dyk-blue.en.png': 'dyk-blue.en.png',
		'dyk-lightblue.en.png': 'dyk-lightblue.en.png',
		'dyk-lightestblue.en.png': 'dyk-lightestblue.en.png',

		'home': 'Home',
		'metrology': 'Metrology',
		'inspection': 'Inspection',
		'analysis': 'Analysis',
		'applications': 'Applications',
		'xraySeries': 'Zeiss X-Ray Series',
		'whyXray': 'Why X-Ray?',

		//Analysis (EN)
		'analysingEvenSmDetails': 'ANALYSING EVEN THE SMALLEST DETAILS',
		'withXray': 'With 3D X-ray microscopy it is possible to deep dive into the inside of your parts. Thanks to highest resolution even the smallest defects and features become visible. In this way analysis of e.g. micro cracks, roughness, grains or material structures is made possible.',
		'discover': 'Discover the high-resolution solution',

		'roughnessAnalysis': 'ROUGHNESS ANALYSIS',
		'surfaceRoughness': 'Surface roughness can be analyzed for both external and internal structures.',

		'structuralAnalysis': 'STRUCTURAL ANALYSIS',
		'structureCharacterization': 'A 3D structure characterization provides important insights thanks to high-resolution X-Ray microscopy.',

		'analysisGrainSize': 'ANALYSIS OF GRAIN SIZE & DISTRIBUTION',
		'grainSizeAndDistribution': 'Grain size and distribution are decisive factors in determining the hardness and strength. This is why it is important to analyze them.',

		'nSituAnalysis': 'IN-SITU & 4D ANALYSIS',
		'withNSituAnalysis': 'With in-situ and 4D analyses, the behavior of materials under external influences and over time can be analyzed.',

		//Applications (EN)

		'onlyOneIsPerfect': 'Only one is perfect inside.',
		'dontGuessXray': 'Don’t guess. X-ray it.',
		'zeissXraySeriesMake': 'ZEISS X-Ray Series. Make the Invisible Visible.',


		'plastics': 'PLASTICS',
		'composites': 'COMPOSITES',
		'assemblies': 'ASSEMBLIES',

		'aluCasting': 'ALU CASTING',
		'materialResearch': 'MATERIAL RESEARCH',
		'lifeSciences': 'LIFE SCIENCES',

		'additiveManufacturing': 'ADDITIVE MANUFACTURING',
		'blade': 'BLADE',
		'oilGas': 'OIL & GAS ',

		'battery': 'BATTERY',
		'electronics': 'ELECTRONICS',
		'multiMaterialParts': 'MULTI-MATERIAL PARTS',

		'onlyOneIsBuilt': 'Only one is built perfectly.',

		'onlyOneIsWillKeep': 'Only one will keep its charge.',

		'onlyOneIsWillSave': 'Only one will save your life.',

		'onlyOneIsWillStay': 'Only one will stay intact.',

		// Inspection (EN)

		'inspectionOfDefects': 'INSPECTION OF DEFECTS',
		'defectsOnTheInside': 'Defects on the inside can significantly affect the functionality and stability of parts. If not detected, they can turn into serious hazards.',
		'DiscoverOurXraySystems': 'Discover our X-ray systems for inspection',

		'cracks': 'CRACKS',
		'underStressCracks': 'Under stress cracks can cause serious problems as they affect the stability of the part.',

		'poresCavities': 'PORES & CAVITIES',
		'poresCavitiesLeadToLoss': 'Pores and cavities lead to loss of firmness and functional impairments.',

		'residuals': 'RESIDUALS',
		'residualsSuchAsSand': 'Residuals such as sand from casting molds or metal powder for 3D printing can be detected quickly and easily in just one scan.',

		'anInvestmentThatPaysOff': 'AN INVESTMENT THAT PAYS OFF',
		'aThoroughInspection': `
			A thorough inspection right after the casting process is important when producing aluminum castings. Companies face high costs if defects are not detected until later in production. This is why investing in an automated inline solution for quality assurance pays off in less than twelve months.
			
			<p>
			
				<a id="3DLink">Check out the automated solutions for 3D inline quality control</a>
			
			</p>
		
			<p>
			
				<a id="2DLink">Check out the automated solutions for 2D inspection</a>

			</p>
		
		`,

		'checkOutTheAutomatedSolutionsForThreeD': 'Check out the automated solutions for 3D inline quality control',

		'checkOutTheAutomatedSolutionsForTwoD': 'Check out the automated solutions for 2D ',

		'inclusions': 'INCLUSIONS',
		'inclusionsOfSlag': 'Inclusions of slag, oxides, sand or tungsten can be a problem during further processing or cause cracks.',

		//Metrology (EN)

		'metrologyOfInnerAndOuter': 'METROLOGY of inner and outer structures',

		'whenAssembled': 'When assembled, parts have to fit together perfectly.',
		'otherwiseTheFunctionality': 'Otherwise the functionality of the final part can be impaired.',
		'withTheHelp': 'With the help of computed tomography (CT) systems from ZEISS, inner and outer structures can be measured accurately. ',

		'checkOutTheAccurate': 'Check out the accurate CT solutions',


		'nominalActualComparison': 'NOMINAL/ACTUAL COMPARISON',
		'deviationsFromTheCAD': 'Deviations from the CAD model or master part are visualized in a false color comparison.',

		'dimensionalControl': 'DIMENSIONAL CONTROL',
		'thanksToComputed': 'Thanks to computed tomography, the dimensional accuracy of complex internal and external features can be checked in just one scan.',

		'wallThicknessAnalysis': 'WALL THICKNESS ANALYSIS',
		'aColorCodedRepresentation': 'A color-coded representation shows the wall thickness of internal structures.',

		//Why X-ray (EN)

		'howDoesItWork': 'HOW DOES X-RAY WORK?',

		'duringTheScanningProcess': 'During the scanning process the part, which is placed in between the source and the detector, is penetrated with X-rays. After the scan the data is merged into a 2D or 3D imaging. Now the part can be analyzed, inspected, and measured.',

		'xrayTube': 'X-RAY TUBE',
		'theXrayTubeUsed': 'The X-ray tube used determines the range of applications: a smaller focal spot for high resolution, a high tube power for quick scans and a multi-focus tube for diversity in application.',


		'part': 'PART',
		'thePartIsPositioned': 'The part is positioned in between the X-ray tube and the image detector.',


		'flatImageDetector': 'FLAT IMAGE DETECTOR',
		'highResolutionApplications': 'High-resolution applications require a high-resolution detector. For high-speed applications, detectors with high frame rates are used.',


		'eightReasonsToXray': '8 REASONS TO X-RAY',

		'analyseInspectAndMeasure': 'Analyse, inspect, and measure also the INSIDE of your part.',
		'desctructioFree': 'DESTRUCTIO- FREE! Cut your part at any position without destroying it.',
		'saveTimeAndMoney': 'SAVE TIME AND MONEY, as no complex fixtures are required.',
		'digitalizeAll': 'DIGITALIZE all internal and external structures — this allows you to reproduce parts even if the CAD model does not exist anymore.',
		'reduceIterationLoops': 'Reduce iteration loops by 30-70% in reverse engineering processes.',
		'preventCostlyProduct': 'Prevent costly product recalls by inspecting 100% in production.',
		'avoidUnnecessaryCosts': 'Avoid unnecessary costs for post-processing processes.',
		'accelerateProductDevelopment': 'Accelerate product development processes by gaining full understanding of material properties.',

		//X-ray series (EN)


		'systems': 'SYSTEMS',
		'software': 'SOFTWARE',
		'service': 'SERVICES',

		'theFocusForZeiss': 'The focus for ZEISS is on the customer and their application.',
		'thisIsWhyWeNot': 'This is why we not only offer hardware, but solutions – in fact the ones that fit your needs best. These consist of hardware systems, software, accessories, and services, precisely tailored to the respective needs. This is only possible at ZEISS.<br /><br />ZEISS X-Ray Series. Make the Invisible Visible.',

		'accessories': 'ACCESSORIES',
		'weOfferAnumber': 'We offer a number of additional options to ensure that you get the most out of your hardware solutions. With ZEISS FixAssist® CT, for example, you can reduce setup times by up to 80%. This makes you even more productive.',

		'noXrayMachine': 'NO X-RAY MACHINE? NO PROBLEM!',
		'youCanEvenXrayYourParts': 'You can even X-ray your parts without your own X-ray system – by using the X-ray scanning service at the ZEISS Quality Excellence Centers. Reap the benefits of ZEISS X-Ray Series and see for yourself without taking any risk.',

		'softwareSolutions': 'SOFTWARE SOLUTIONS',

		'zeissHasOtherAdvanced': 'ZEISS has other advanced software solutions to choose from besides the trusted ZEISS CALYPSO evaluation software. For instance, you can capture your 3D data with ZEISS METROTOM OS, vusualize and evaluate it in ZEISS NEO insights, and finally collect it and get reports in ZEISS PiWeb.',

		'inTheLab': 'IN THE LAB',
		'inspectionMetrologyAnalysis': 'INSPECTION, METROLOGY & ANALYSIS',

		'productionLine': 'IN THE PRODUCTION LINE',
		'inspectionMetrology': 'INSPECTION & METROLOGY',

		'highPrecisionMetrologyIspection': 'HIGH-PRECISION METROLOGY & INSPECTION',

		'highResolutionAnalysisIspection': 'HIGH-RESOLUTION ANALYSIS & INSPECTION',

		'fastAutomatedThreeDIspection': 'FAST & AUTOMATED 3D INSPECTION & METROLOGY',

		'fastAutomatedTwoDIspection': 'FAST & AUTOMATED 2D INSPECTION',

		'boselloFamily': 'BOSELLO family',
		'FastestTwoDInlineInspection': 'Fastest 2D inline inspection in production with BOSELLO HIGH TECHNOLOGY – A ZEISS company',

		'metrotomFamily': 'METROTOM family',
		'highPrecisionThreeDScans': 'High-precision 3D scans for metrology and inspection in the lab.',

		'voluMaxFamily': 'VoluMax family',
		'inlineComputedTomography': 'Inline computed tomography systems ensure fast and automated inline 3D inspection & metrology.',

		'fastInlineMetrology': 'Fast inline metrology of small plastic parts',

		'inlineMetrologyOfMidSized': 'Inline metrology of mid sized plastic parts',


		'xradiaFamily': 'Xradia family',
		'xrayMicroscopesFor': 'X-ray microscopes for high-resolution images to capture even the smallest details of your part.',

		'partSize': 'Part size',
		'accuracy': 'Accuracy',
		'speed': 'Speed',
		'resolution': 'Resolution',
		'partDensity': 'Part density',
		'footprint': 'Footprint'
	},
	'de': {
		'back': 'Zurück',

		'dyk-black.en.png': 'dyk-black.de.png',
		'dyk-blue.en.png': 'dyk-blue.de.png',
		'dyk-lightblue.en.png': 'dyk-lightblue.de.png',
		'dyk-lightestblue.en.png': 'dyk-lightestblue.de.png',

		'home': 'Startseite',
		'metrology': 'Messtechnik',
		'inspection': 'Inspektion',
		'analysis': 'Analyse',
		'applications': 'Anwendungen',
		'xraySeries': 'Zeiss X-Ray Series',
		'whyXray': 'Warum röntgen?',

		//Analysis (DE)
		'analysingEvenSmDetails': 'ANALYSE SELBST KLEINSTER DETAILS',
		'withXray': 'Mit der 3D-Röntgenmikroskopie ist es möglich, tief in das Innere Ihrer Teile einzutauchen. Dank höchster Auflösung werden selbst kleinste Fehler und Merkmale sichtbar. Auf diese Weise wird die Analyse von z. B. Mikrorissen, Rauheit, Korngrößen oder Materialstrukturen ermöglicht.',
		'discover': 'Entdecken Sie die hochauflösende Lösungen',

		'roughnessAnalysis': 'ANALYSE DER RAUHEIT',
		'surfaceRoughness': 'Die Oberflächenrauheit kann sowohl von Außen- als auch von Innenstrukturen analysiert werden.',

		'structuralAnalysis': 'GEFÜGEANALYSE',
		'structureCharacterization': 'Eine 3D-Strukturcharakterisierung liefert dank hochauflösender Röntgenmikroskopie wichtige Erkenntnisse.',

		'analysisGrainSize': 'ANALYSE DER KORNGRÖßE UND -VERTEILUNG',
		'grainSizeAndDistribution': 'Die Korngröße und -verteilung bestimmt die Härte und Festigkeit von Bauteilen. Deshalb ist es wichtig, diese zu analysieren.',

		'nSituAnalysis': 'IN-SITU & 4D-ANALYSE',
		'withNSituAnalysis': 'Mittels in-situ und 4D Analysen lässt sich das Verhalten von Materialien unter Umwelteinflüssen und im Zeitverlauf untersuchen.',

		//Applications (DE)

		'plastics': 'Kunststoffe',
		'composites': 'Verbundwerkstoffe',
		'assemblies': 'Zusammen- baukontrolle',

		'aluCasting': 'Aluguss',
		'materialResearch': 'Materialforschung',
		'lifeSciences': 'Biowissenschaften',

		'additiveManufacturing': 'Additive Fertigung',
		'blade': 'Turbinenschaufel',
		'oilGas': 'Öl & Gas',

		'battery': 'Batterie',
		'electronics': 'Elektronik',
		'multiMaterialParts': 'MULTIMATERIAL',

		'onlyOneIsPerfect': ' Nur ein Bauteil ist innen einwandfrei.',
		'dontGuessXray': 'Nicht raten. Durchleuchten!',
		'zeissXraySeriesMake': 'ZEISS X-Ray Serie. Machen Sie das Unsichtbare sichtbar.',

		'onlyOneIsBuilt': 'Nur ein Bauteil ist perfekt gebaut.',

		'onlyOneIsWillKeep': 'Nur eine Batterie bleibt aufgeladen.',

		'onlyOneIsWillSave': 'Nur einer wird Ihnen das Leben retten.',

		'onlyOneIsWillStay': 'Nur ein Bauteil bleibt intakt.',

		// Inspection (DE)

		'inspectionOfDefects': 'DEFEKTANALYSE',
		'defectsOnTheInside': 'Defekte im Inneren können die Funktionalität und Stabilität von Teilen erheblich beeinträchtigen. Wenn sie nicht erkannt werden, können sie zu ernsthaften Gefahren werden.',

		'DiscoverOurXraySystems': 'Entdecken Sie unsere Röntgensysteme für die Inspektion',

		'cracks': 'RISSE',
		'underStressCracks': 'Unter Belastung können Risse große Probleme verursachen, da sie die Stabilität des Bauteils beeinträchtigen.',

		'poresCavities': 'POREN & LUNKER',
		'poresCavitiesLeadToLoss': 'Poren und Lunker führen zu Einbußen in der Festigkeit und zu Funktionsbeeinträchtigungen.',

		'residuals': 'RÜCKSTÄNDE',
		'residualsSuchAsSand': 'Rückstände wie Sand aus Gießformen oder Metallpulver vom 3D-Druck können mit nur einem Scan schnell und einfach erkannt werden.',

		'anInvestmentThatPaysOff': 'EINE INVESTITION, DIE SICH AUSZAHLT',
		'aThoroughInspection': `
			Bei der Herstellung von Alugussteilen ist eine sorgfältige Prüfung direkt nach dem Gießprozess wichtig. Den Unternehmen entstehen hohe Kosten, wenn Fehler erst spät in der Produktion erkannt werden. Deshalb zahlt sich die Investition in eine automatisierte Inline-Lösung für die Qualitätssicherung in weniger als zwölf Monaten aus.
			
			<p>
			
				<a id="3DLink">Sehen Sie sich die automatisierten Lösungen für 3D Qualitätssicherung in der Linie an.</a>
			
			</p>
		
			<p>
			
				<a id="2DLink">Entdecken Sie die automatisierten Lösungen für 2D Defektanalyse</a>

			</p>
		
		`,

		'inclusions': 'EINSCHLÜSSE',
		'inclusionsOfSlag': 'Schlacken-, Oxid-, Sand- oder Wolframeinschlüsse können ein Problem bei der Weiterverarbeitung darstellen oder Risse verursachen.',

		//Metrology (DE)

		'metrologyOfInnerAndOuter': 'Das Messen innen- und außenliegender Strukturen',

		'whenAssembled': 'Bei der Montage müssen die Teile perfekt zusammenpassen.',
		'otherwiseTheFunctionality': 'Andernfalls kann die Funktionalität des Endteils beeinträchtigt werden.',
		'withTheHelp': 'Mit Hilfe der Computertomographen von ZEISS können Außen- und Innenstrukturen genau gemessen werden.',

		'checkOutTheAccurate': 'Informieren Sie sich über die präzisen CT-Lösungen',

		'nominalActualComparison': 'SOLL-IST-VERGLEICH',
		'deviationsFromTheCAD': 'Abweichungen zum CAD-Modell oder Master-Bauteil werden in einem Falschfarbenvergleich visualisiert.',

		'dimensionalControl': 'ÜBERPRÜFUNG DER MAßHALTIGKEIT',
		'thanksToComputed': 'Dank Computertomographie kann die Maßhaltigkeit komplexer innen- und außenliegender Merkmale in nur einem Scan überprüft werden.',

		'wallThicknessAnalysis': 'WANDSTÄRKENANALYSE',
		'aColorCodedRepresentation': 'Eine farbcodierte Darstellung zeigt die Wandstärke auch von innenliegenden Strukturen.',

		//Why X-ray (DE)

		'howDoesItWork': 'Wie funktioniert die Röntgentechnologie?',

		'duringTheScanningProcess': 'Während des Scanvorgangs wird das Bauteil, das sich zwischen Quelle und Detektor befindet, mit Röntgenstrahlen durchleuchtet. Die Daten werden nach dem Scan zu einer 2D- oder 3D-Bildgebung zusammengeführt. Nun kann das Bauteil analysiert, inspiziert und gemessen werden.',

		'xrayTube': 'Röntgenröhre',
		'theXrayTubeUsed': 'Der verwendete Röhrentyp bestimmt das Einsatzspektrum – kleiner Brennfleck für hohe Auflösung, hohe Röhrenleistung für schnelle Scans, Multifokus-Röhre für Variabilität in der Anwendung.',


		'part': 'BAUTEIL',
		'thePartIsPositioned': 'Das Teil wird zwischen der Röntgenröhre und dem Bilddetektor positioniert.',


		'flatImageDetector': 'FLACHBILDDETEKTOR',
		'highResolutionApplications': 'Hochauflösende Anwendungen erfordern einen hochauflösenden Detektor; für High-Speed-Anwendungen werden Detektoren mit hohen Framerates eingesetzt.',


		'eightReasonsToXray': '8 Gründe für den Einsatz der Röntgentechnologie',

		'analyseInspectAndMeasure': 'Analysieren, inspizieren und messen Sie auch das Innere Ihres Teils.',
		'desctructioFree': 'ZERSTÖRUNGSFREI! Beschneiden Sie Ihr Bauteil an jeder beliebigen Stelle, ohne es zu zerstören.',
		'saveTimeAndMoney': 'SPAREN SIE ZEIT UND GELD, da keine komplexe Aufspannung nötig ist.',
		'digitalizeAll': 'DIGITALISIEREN Sie alle internen und externen Strukturen – so können Sie Bauteile reproduzieren, selbst wenn kein CAD-Modell mehr vorliegt.',
		'reduceIterationLoops': 'Reduzierung von Iterationsschleifen um 30-70% bei Reverse-Engineering-Prozessen',
		'preventCostlyProduct': 'Verhindern Sie kostspielige Produktrückrufe, indem Sie 100% Ihrer Teile in der Produktion prüfen.',
		'avoidUnnecessaryCosts': 'Vermeidung unnötiger Kosten für Nachbearbeitungsprozesse.',
		'accelerateProductDevelopment': 'Beschleunigung von Produktentwicklungsprozessen durch tiefe Einblicke in die Materialeigenschaften Ihres Bauteils.',

		//X-ray series (DE)

		'systems': 'Systeme',
		'software': 'SOFTWARE',
		'service': 'SERVICES',

		'theFocusForZeiss': 'Für ZEISS steht der Kunde mit seiner Anwendung im Fokus.',
		'thisIsWhyWeNot': 'Für ZEISS steht der Kunde mit seiner Anwendung im Fokus. Daher bieten wir nicht nur Geräte, sondern Lösungen – und zwar die genau Passende. Diese setzen sich zusammen aus Hardwaresystemen, Software, Zubehör und Serviceleistungen, exakt abgestimmt auf die jeweiligen Bedürfnisse. Das gibt es so nur bei ZEISS.',

		'accessories': 'ZUBEHÖR',
		'weOfferAnumber': 'Wir bieten zahlreiche Zusatzoptionen, damit Sie das Beste aus Ihren Hardwarelösungen herausholen können. So lassen sich beispielsweise mit ZEISS FixAssist® CT Ihre Rüstzeiten um bis zu 80% reduzieren. Das macht Sie noch produktiver.',

		'noXrayMachine': 'Kein Röntgensystem? Kein Problem!',
		'youCanEvenXrayYourParts': 'Ihre Bauteile können Sie sogar ganz ohne eigenes Röntgengerät durchleuchten – mit Röntgenprüfungen als Dienstleistung in den ZEISS Quality Excellence Centern. Profitieren Sie von den Vorteilen der ZEISS X-Ray Serie und lassen Sie sich davon überzeugen, ohne ein Risiko einzugehen.',

		'softwareSolutions': 'SOFTWARE',

		'zeissHasOtherAdvanced': 'Neben der bewährten Auswertesoftware ZEISS CALYPSO bietet ZEISS weitere fortschrittliche Softwarelösungen an. Sie können beispielsweise Ihre 3D-Daten mit ZEISS METROTOM OS erfassen, in ZEISS NEO insights visualisieren und auswerten – und anschließend in ZEISS PiWeb in einem Protokoll darstellen und analysieren.',

		'inTheLab': 'IM LABOR',
		'inspectionMetrologyAnalysis': 'INSPEKTION, MESSTECHNIK & ANALYSE',

		'productionLine': 'IN DER PRODUKTIONSLINIE',
		'inspectionMetrology': 'INSPEKTION & MESSTECHNIK',

		'highPrecisionMetrologyIspection': 'HOCHPRÄZISE MESSTECHNIK & INSPEKTION',

		'highResolutionAnalysisIspection': 'HOCHAUFLÖSENDE ANALYSE & INSPEKTION',

		'fastAutomatedThreeDIspection': 'SCHNELLE & AUTOMATISIERTE 3D-INSPEKTION & MESSTECHNIK',

		'fastAutomatedTwoDIspection': 'SCHNELLE & AUTOMATISIERTE 2D-INSPEKTION',

		'boselloFamily': 'BOSELLO FAMILIE',
		'FastestTwoDInlineInspection': 'Schnellste 2D-Inline-Inspektion in der Produktion mit BOSELLO HIGH TECHNOLOGY – A ZEISS company',

		'metrotomFamily': 'METROTOM FAMILIE',
		'highPrecisionThreeDScans': 'Hochpräzise 3D-Scans für Messtechnik und Inspektion im Labor.',

		'voluMaxFamily': 'VoluMax FAMILIE',
		'inlineComputedTomography': 'Inline-CTs sorgen für eine schnelle und automatisierte 3D-Inspektion und -Messtechnik in der Linie.',

		'fastInlineMetrology': 'Fast inline metrology of small plastic parts',

		'inlineMetrologyOfMidSized': 'Inline metrology of mid sized plastic parts',


		'xradiaFamily': 'Xradia FAMILIE',
		'xrayMicroscopesFor': 'Röntgenmikroskope für hochauflösende Bilder, um auch kleinste Details Ihres Teils zu erfassen.',

		'partSize': 'Part size',
		'accuracy': 'Accuracy',
		'speed': 'Speed',
		'resolution': 'Resolution',
		'partDensity': 'Part density',
		'footprint': 'Footprint'
	},
	'zh': {
		"back": "后退",
		"home": "主页",
		"metrology": "测量",
		"inspection": "检测",
		"analysis": "分析",
		"applications": "应用",
		"xraySeries": "蔡司X射线系列",
		"whyXray": "为什么采用X射线系统？",


		"analysingEvenSmDetails": "分析极其微小的细节",
		"withXray": "利用三维 X射线显微镜，可深入洞悉工件的内部结构。",
		"discover": "了解高分辨率解决方案",

		"roughnessAnalysis": "粗糙度分析",
		"surfaceRoughness": "可分析内外部结构的表面粗糙度",

		"structuralAnalysis": "结构分析",
		"structureCharacterization": "高分辨率X射线显微镜可高效呈现三维结构特征。",

		"analysisGrainSize": "分析颗粒尺寸及分布",
		"grainSizeAndDistribution": "颗粒尺寸及分布是决定硬度及强度的关键要素。",

		"nSituAnalysis": "原位及四维分析",
		"withNSituAnalysis": "可分析材料在外界影响下和随时间推移的表现。",



		"onlyOneIsPerfect": "内部结构，一览无遗。",
		"dontGuessXray": "别猜了，X-ray它。",
		"zeissXraySeriesMake": "蔡司X-ray，见所未见。Or 蔡司X-ray,可见不可见。",


		"plastics": "塑料",
		"composites": "复合材料",
		"assemblies": "组装件",

		"aluCasting": "铝压铸",
		"materialResearch": "材料研究",
		"lifeSciences": "生命科学",

		"additiveManufacturing": "增材制造",
		"blade": "叶片",
		"oilGas": "油气",

		"battery": "电池",
		"electronics": "电子",
		"multiMaterialParts": "多材料零件",

		"onlyOneIsBuilt": "仅一个内部结构无瑕疵。",

		"onlyOneIsWillKeep": "仅一个可正常使用。",

		"onlyOneIsWillSave": "仅一个可挽救您的生命。",

		"onlyOneIsWillStay": "仅一个完好无损。",



		"inspectionOfDefects": "缺陷检测",
		"defectsOnTheInside": "内部缺陷可严重影响工件的功能及稳定性。",
		"DiscoverOurXraySystems": "探索我们的X射线检测系统",

		"cracks": "裂纹",
		"underStressCracks": "裂纹于应力作用下可引发严重问题，并影响工件的稳定性。",

		"poresCavities": "气孔及缩孔",
		"poresCavitiesLeadToLoss": "气孔及缩孔可导致刚性下降及功能缺失。",

		"residuals": "残留物 ",
		"residualsSuchAsSand": "仅需一次扫描，即可快捷检测残留物，例如压铸残砂，或3D打印金属粉末。",

		"anInvestmentThatPaysOff": "物有所值的投资",
		"aThoroughInspection": "铝铸件生产过程中，于铸造工序后对工件进行全检非常重要。<p><a id=\"3dlink\">了解三维在线质量控制自动化解决方案</a></p><p><a id=\"2dlink\">了解二维检测自动化解决方案</a></p>",


		"checkOutTheAutomatedSolutionsForThreeD": "了解三维在线质量控制自动化解决方案",

		"checkOutTheAutomatedSolutionsForTwoD": "了解二维检测自动化解决方案",

		"inclusions": "夹杂物",
		"inclusionsOfSlag": "炉渣、氧化物、砂或钨等夹杂可对后续工序产生影响或导致裂纹。",



		"metrologyOfInnerAndOuter": "内外结构测量",

		"whenAssembled": "组装时各部件须精确装配。",
		"otherwiseTheFunctionality": "以避免最终成品功能受影响。",
		"withTheHelp": "借助蔡司的计算机断层扫描（CT）系统，可精准测量样品内外部结构。",

		"checkOutTheAccurate": "了解高精度CT解决方案",


		"nominalActualComparison": "公称值与实际值对比",
		"deviationsFromTheCAD": "通过轮廓偏差比对的色差图来表征与CAD模型或标准件的偏差。",

		"dimensionalControl": "尺寸控制",
		"thanksToComputed": "借助计算机断层扫描，仅需一次扫描，即可实现复杂内部和外部结构的尺寸测量。",

		"wallThicknessAnalysis": "壁厚分析",
		"aColorCodedRepresentation": "用色差图表征内部结构的壁厚。",



		"howDoesItWork": "X射线工作原理",

		"duringTheScanningProcess": "将工件放置于射线源及探测器之间进行X射线透射。扫描后，采集的数据将合并二维或三维成像。此后，便可对工件进行分析、检测及测量。",

		"xrayTube": "X射线管",
		"theXrayTubeUsed": "所选择X射线管决定了应用范围：用于高分辨率的更小焦点X射线管，用于快速扫描的高功率X射线管，以及涵盖多样化应用的多焦点X射线管。",


		"part": "工件",
		"thePartIsPositioned": "将工件置于X射线管及探测器之间。",


		"flatImageDetector": "平板探测器",
		"highResolutionApplications": "高分辨率检测需要采用高分辨率探测器。",


		"eightReasonsToXray": "选择X射线的八个理由",

		"analyseInspectAndMeasure": "分析、检测及测量工件内部",
		"desctructioFree": "无损检测！可在任何截面对工件进行无损分析。",
		"saveTimeAndMoney": "节省时间及成本，无需复杂夹具。",
		"digitalizeAll": "将所有内外部结构数字化 - 即便无三维模型，也可复制工件。",
		"reduceIterationLoops": "在逆向工程流程中将迭代循环次数缩减30-70％",
		"preventCostlyProduct": "在生产过程中实现100％全测，避免因产品召回而造成损失",
		"avoidUnnecessaryCosts": "避免后期处理的不必要成本",
		"accelerateProductDevelopment": "通过充分了解材料属性，加速产品开发进程",




		"systems": "系统",
		"software": "软件",
		"service": "服务",

		"theFocusForZeiss": "我们关注于客户及其应用。",
		"thisIsWhyWeNot": "为此，我们不仅提供设备，更可提供整体解决方案，旨在更好地满足您的需求。我们的方案包括硬件系统、软件、附件及服务，并可根据客户需求量身定制。蔡司让这成为可能。",

		"accessories": "附件",
		"weOfferAnumber": "我们为您提供了众多增值选项，确保您可以充分发挥解决方案优势。ZEISS FixAssist® CT可将工件预调时间缩短80%。从而帮助您提高生产效率。",

		"noXrayMachine": "没有X射线系统？没问题！",
		"youCanEvenXrayYourParts": "借助蔡司应用服务中心的X射线扫描服务，即使没有自己的X射线系统，也可对工件进行X射线检测。",

		"softwareSolutions": "软件",

		"zeissHasOtherAdvanced": "除了成熟可靠的ZEISS CALYPSO测量软件之外，蔡司还提供其他先进的软件解决方案供您选择。",

		"inTheLab": "在实验室",
		"inspectionMetrologyAnalysis": "检测、测量及分析",

		"productionLine": "在生产线",
		"inspectionMetrology": "检测及测量",

		"highPrecisionMetrologyIspection": "高精度测量及检测",

		"highResolutionAnalysisIspection": "高分辨率分析及检测",

		"fastAutomatedThreeDIspection": "快速及自动化三维检测与测量",

		"fastAutomatedTwoDIspection": "快速及自动化二维检测",

		"boselloFamily": "BOSELLO系列",
		"FastestTwoDInlineInspection": "宝石隆高科技（蔡司旗下公司）提供极其快速的二维在线检测解决方案 ",

		"metrotomFamily": "METROTOM系列",
		"highPrecisionThreeDScans": "高精度三维扫描，用于实验室测量及检测。",

		"voluMaxFamily": "VOLUMAX系列",
		"inlineComputedTomography": "在线计算机断层扫描系统可确保快速自动化在线三维检测及测量。",

		"fastInlineMetrology": "小型塑料零件的快速在线测量",

		"inlineMetrologyOfMidSized": "中型塑料零件的在线测量",


		"xradiaFamily": "XRADIA系列",
		"xrayMicroscopesFor": "X射线显微镜可提供高分辨率图像，您可以观察到工件的微小细节。",

		"partSize": "零件尺寸",
		"accuracy": "精度",
		"speed": "速度",
		"resolution": "分辨率",
		"partDensity": "零件密度",
		"footprint": "足迹",
	}
};

const i18n = new VueI18n({
	locale: 'en', // set locale
	fallbackLocale: 'de', // set fallback locale
	messages, // set locale messages
});

export default i18n;
